import { createFileRoute } from "@tanstack/react-router";
import { PrivacyContent } from "@/components/legal/privacy";
import { Language } from "@linqx/i18n";
import { seo } from "@/lib/seo";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: seo({
      title: Language.getKey("landing_meta_privacy_title"),
      description: Language.getKey("landing_meta_privacy_description"),
      url: "https://getlinqx.com/privacy",
    }),
  }),
  component: PrivacyContent,
});
